import { render, staticRenderFns } from "./jituan.vue?vue&type=template&id=06866f8d&scoped=true&"
import script from "./jituan.vue?vue&type=script&lang=js&"
export * from "./jituan.vue?vue&type=script&lang=js&"
import style0 from "./jituan.vue?vue&type=style&index=0&id=06866f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06866f8d",
  null
  
)

export default component.exports